import { render, staticRenderFns } from "./mobileGameDown.vue?vue&type=template&id=7751b8f0&scoped=true&"
import script from "./mobileGameDown.vue?vue&type=script&lang=js&"
export * from "./mobileGameDown.vue?vue&type=script&lang=js&"
import style0 from "./mobileGameDown.vue?vue&type=style&index=0&id=7751b8f0&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7751b8f0",
  null
  
)

export default component.exports